import { createSlice } from "@reduxjs/toolkit";
var initialState = {
  open: false,
  linkId: null
};
var shippingAndReturnsOverlay = createSlice({
  name: "shippingAndReturnsOverlay",
  initialState: initialState,
  reducers: {
    openShippingAndReturnsOverlay: function openShippingAndReturnsOverlay(state, action) {
      state.open = true;
      state.linkId = action.payload;
    },
    closeShippingAndReturnsOverlay: function closeShippingAndReturnsOverlay(state) {
      state.open = false;
      state.linkId = null;
    }
  }
});
var actions = shippingAndReturnsOverlay.actions,
    reducer = shippingAndReturnsOverlay.reducer;
var openShippingAndReturnsOverlay = actions.openShippingAndReturnsOverlay,
    closeShippingAndReturnsOverlay = actions.closeShippingAndReturnsOverlay;
export { openShippingAndReturnsOverlay, closeShippingAndReturnsOverlay };
export default reducer;